import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { fetchClassificationAction } from "../myResultsActions";
import { fetchSubleaguesListAction } from "../../Subleagues/subleaguesActions";
import { FormattedMessage, injectIntl } from "react-intl";

const Classifications = ({
  game,
  strings,
  general,
  current,
  onClassificationClick,
  onSubleagueClick,
  intl,
  hasOpenSubLeagues,
  hasSubLeagues,
}) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const mobile = useSelector((state) => state.mobile);
  const handleClassificationClick = (item, i) => {
    switch (item.type) {
      case "classification--general":
        onClassificationClick(item);
        break;
      case "subleagues":
        onSubleagueClick(item.id, game);
    }

    if (i !== activeIndex) {
      setActiveIndex(i);
    }
  };

  if (!game || !strings) {
    return null;
  }

  const classifications = mobile.hasSubleagues
    ? general.concat([
        {
          id: "prize",
          type: "subleagues",
          name: intl.formatMessage({ id: "ranking.subleagues" }),
        },
      ])
    : general;

  return (
    <div className="results-mobile-classifications">
      {classifications.map((item, i) => (
        <button
          onClick={() => handleClassificationClick(item, i)}
          className={activeIndex === i ? "active__btn" : ""}
          key={item.id}
        >
          {item.name}
        </button>
      ))}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    general: state.classifications.general,
    current: state.classifications.current,
    game: state.games.current,
    strings: state.games.strings,
    hasOpenSubLeagues: state.games.hasOpenSubLeagues,
    hasSubLeagues: state.games.hasSubLeagues,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onClassificationClick: (classification) =>
      dispatch(fetchClassificationAction(classification)),
    onSubleagueClick: (type, game) =>
      dispatch(fetchSubleaguesListAction(type, game)),
  };
};

const ClassificationsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(Classifications));

export default ClassificationsContainer;
